import { log10 } from "chart.js/helpers";

export default () => ({
  tags: [],
  selectedCategories: [],

  initFilter(items) {
    this.tags = items;

    this.setInitialFilter();
  },

  setInitialFilter() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const categoryId = urlParams.get("category");

    // set initial filter if query param in url exists
    if (categoryId) {
      return this.selectedCategories.push(categoryId);
    }

    // otherwise show all
    this.selectedCategories.push("all");
  },

  toggleCategory(category) {
    // remove from array if already exists
    if (this.selectedCategories.includes(category.identifier)) {
      const index = this.selectedCategories.indexOf(category.identifier);

      return this.selectedCategories.splice(index, 1);
    }

    if (this.selectedCategories.includes("all")) {
      this.selectedCategories = [];
    }

    if (category.identifier === "all") {
      this.selectedCategories = [];
    }

    this.selectedCategories.push(category.identifier);
  },

  isSelected(category) {
    return this.selectedCategories.includes(category.identifier);
  },

  isVisible(item) {
    return (
      this.selectedCategories.includes(item.category) ||
      this.selectedCategories.includes("all")
    );
  },
});
